import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { mdiMessageTextOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Drawer, Hidden, Slide } from '@material-ui/core';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import ChatMenuContent from './components/ChatMenuContent';
import { useSelector } from 'react-redux';
import { getChatControlData } from 'components/ChatDialog/store/slices/chatSlice';
import SideBadge from 'components/SideBadge/SideBadge';
import { getProjectEmailData } from 'store/projectEmail/projectEmailSlice';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
));
Transition.displayName = 'Transition';

const useStyles = makeStyles((theme) => ({
  iconButton: {
    height: 40,
    padding: 0,
    width: 40,
    [theme.breakpoints.up('sm')]: {
      margin: '0 4px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

const ChatButton = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const classes = useStyles();
  const { threads } = useSelector(getChatControlData);
  const { unreadMessages } = useSelector(getProjectEmailData);

  const threadsWithUnreadMessages = Object.values(threads).filter(
    (thread) => thread.unreadMessagesCount > 0
  ).length;

  const projectsWithUnreadEmailMessages = Object.values(unreadMessages).filter(
    (count) => count > 0
  ).length;

  const totalUnreadCount =
    threadsWithUnreadMessages + projectsWithUnreadEmailMessages;

  return (
    <>
      <Hidden xsDown>
        <IconButton
          className={classes.iconButton}
          onClick={() => setDrawerOpen(true)}
        >
          <SideBadge
            badgeContent={totalUnreadCount}
            color="secondary"
            invisible={totalUnreadCount === 0}
          >
            <Icon path={mdiMessageTextOutline} size={1} />
          </SideBadge>
        </IconButton>
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <ChatMenuContent />
        </Drawer>
      </Hidden>
      <Hidden smUp>
        <IconButton
          className={classes.iconButton}
          onClick={() => setDrawerOpen(true)}
        >
          <SideBadge
            badgeContent={totalUnreadCount}
            color="secondary"
            invisible={totalUnreadCount === 0}
          >
            <Icon path={mdiMessageTextOutline} size={1} />
          </SideBadge>
        </IconButton>
        <Dialog
          fullScreen
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          TransitionComponent={Transition}
        >
          <ChatMenuContent />
        </Dialog>
      </Hidden>
    </>
  );
};

export default ChatButton;
